module.exports = __webpack_public_path__ + "static/img/logo.62cec407.png";